export const CROP_YEARS = [2000, 2015, 2019];
export function cropLayers(year, previous) {
  const selected = CROP_YEARS.includes(year) ? year : 2019;
  return { ...previous, pina2000: selected === 2000, pina2015: selected === 2015, pina2019: selected === 2019 };
}
export function restoreCropLayers(params, defaults) {
  try {
    const explicit = JSON.parse(params.get('eit_capas'));
    if (explicit && !Array.isArray(explicit) && ['pina2000', 'pina2015', 'pina2019'].some((key) => typeof explicit[key] === 'boolean')) {
      return Object.fromEntries(Object.entries(defaults).map(([key, value]) => [key, typeof explicit[key] === 'boolean' ? explicit[key] : value]));
    }
  } catch { /* Use the thematic year. */ }
  return cropLayers(Number(params.get('eit_anio')), defaults);
}
let rasterRequest = 0;
// Keep the identified raster until visible tiles from the candidate have loaded.
export function prepareRaster(map, year, source, onStatus) {
  const candidate = `sentinel-candidate-${year}-${++rasterRequest}`;
  const layer = `${candidate}-layer`;
  let ended = false;
  let commitTimer;
  const cleanup = () => {
    ended = true; clearTimeout(timer); clearTimeout(commitTimer); map.off('sourcedata', loaded); map.off('error', failed);
    // A source must survive the current MapLibre tile event propagation.
    setTimeout(() => {
      if (!map.getStyle()) return;
      if (map.getLayer(layer)) map.removeLayer(layer);
      if (map.getSource(candidate)) map.removeSource(candidate);
    }, 0);
  };
  const failed = (event) => {
    if (event.sourceId && event.sourceId !== candidate) return;
    if (!event.sourceId && !String(event.error?.message || '').includes(source.getTileUrl(year).split('/default/')[0])) return;
    cleanup(); onStatus({ state: 'error', requested: year });
  };
  const loaded = (event) => {
    if (ended || event.sourceId !== candidate || !event.isSourceLoaded || !event.coord) return;
    ended = true;
    commitTimer = setTimeout(() => {
      const active = map.getSource('sentinel-tiles');
      if (!active) return;
      active.setTiles([source.getTileUrl(year)]);
      cleanup(); onStatus({ state: 'ready', requested: year, effective: year });
    }, 0);
  };
  const timer = setTimeout(() => { if (!ended) { cleanup(); onStatus({ state: 'error', requested: year }); } }, 20000);
  onStatus({ state: 'loading', requested: year });
  map.on('sourcedata', loaded); map.on('error', failed);
  map.addSource(candidate, { type: 'raster', tiles: [source.getTileUrl(year)], tileSize: 256, attribution: source.attribution });
  map.addLayer({ id: layer, type: 'raster', source: candidate, paint: { 'raster-opacity': 0 } }, 'sentinel-layer');
  return cleanup;
}
